import { gsap } from "gsap";
import { Power0 } from 'gsap/all';
import {spanWrapAllLetters} from '../../helpers/texthelper';
import ScrollMagic from 'scrollmagic';
//import {PopInBodyScrollEffect} from '../anim8.effect.scroll.text-popin';
import {PopInBodyScrollEffect} from '../anim8.effect.scroll.text-popin-section';

export default class Anim8_news {


	constructor(scroll, sceneFactory, controller, domElem) {

		if( !domElem ) {
			console.error('DOM ELEMENT FOR NEWS NOT FOUND');
			return;
		}

		this.animatedIn = false;
		this.animatedOut = false;
		this.useScrollTrigger = true;

		this.domElem = domElem;
		this.sceneElemName = this.domElem.getAttribute('data-anchor').toLowerCase();
		this.sceneDuration = this.domElem.getAttribute('data-duration');
		this.sceneOffset = this.domElem.getAttribute('data-offset');
		this.sceneTriggerHook = this.domElem.getAttribute('data-trigger-hook');

		this.dimensions = domElem.getBoundingClientRect();
		this.domCards = domElem.querySelectorAll('.news-card');

		if( !this.domCards ||  this.domCards.length < 0 ) {
			console.error('DOM CARD NEWS NOT FOUND');
			return;
		}

		//this.setTextLetters();

		this.initTimeline();

		if( ![undefined,null].includes(scroll) && ![undefined,null].includes(controller) ) {
			this.initScrollMagic(scroll, sceneFactory, controller);
		} else {
			//this.defaultTween();
		}

		console.warn("[Anim8_news.js] loaded");

		return this.timeline;
		
	}

	initTimeline() {

		this.timeline = gsap.timeline({
			delay: 0,
			defaults: {
				ease: "power1.inOut"
			},
			scrollTrigger: (this.useScrollTrigger === true ? this.scrollTriggerOptions() : false),
			onComplete: () => {
				console.log("Anim8_news.js finished");
			},
		});
	}

	scrollTriggerOptions() {

		let initialised = false;
		return {
			trigger: this.domElem,
			pin: false, // pin the trigger element while active
			start: 'top bottom', // when the top of the trigger hits the top of the viewport
			end: `+=${(this.dimensions.height*1)}`,
			//end: `+=${this.dimensions.height + (this.dimensions.height*.25)}`,
			//end: '+=500', // end after scrolling 500px beyond the start
			//end: 'top bottom',
			//toggleActions: "play none none reset",
			scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			//markers: {startColor:"green", endColor:"red", fontSize:"12px"},
			onToggle: self => console.log(`${this.sceneElemName} active:`, self.isActive),
			onEnter: (({progress, direction, isActive}) =>{

				/** /
				if( initialised === false ) {
					this.animatedText = new PopInBodyScrollEffect(this.domElem.querySelector('.text-wrapper'));
					this.animatedText.play();
					
					initialised = true;
				} else {
					this.animatedText.play();
				}
				/**/

				this.playCards();
			}),
		}

	}

	playCards() {
		gsap
		.fromTo(
			this.domCards, 
			{
				y: `-5%`,
				webkitFilter: 'blur(10px)',
				autoAlpha: 0,
				scale: .75,
			},
			{
				y: `0%`,
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
				scale: 1,
				//ease: Power0.easeInOut,
				ease: Power0.easeOut,
				//stagger: .1,
				stagger: {
					// wrap advanced options in an object
					each: 0.08,
					//from: 'center',
					//from: 'end',
					//from: 'edges',
					from: 'start',
					grid: 'auto',
					ease: Power0.easeOut,
					//ease: Power0.easeInOut,
					//repeat: -1 // Repeats immediately, not waiting for the other staggered animations to finish
				},
				duration: .25,
				overwrite: false,
				//immediateRender: false,
				onComplete: ((e)=>{
					//console.log('CARD ANIMATION COMPLETE', e);
				})
			},
			'-=.5'
		);
		gsap
		.fromTo(
			this.domElem.querySelectorAll('.news-meta'), 
			{
				y: `-10%`,
				autoAlpha: 0,
			},
			{
				y: `0%`,
				autoAlpha: 1,
				ease: Power0.easeInOut,
				stagger: .1,
				overwrite: false,
				//immediateRender: false,
			},
			'-=.5'
		)

		gsap
		.fromTo(
			this.domElem.querySelector('.custom-call-to-action'), 
			{
				webkitFilter: 'blur(20px)',
				autoAlpha: 0,
				scale: 1.2,
			},
			{
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
				scale: 1,
				overwrite: false,
				//immediateRender: false,
				ease: Power0.easeInOut
				//ease: Power0.easeOut
			},
			'-=.5'
		)
	}

	initScrollMagic(scroll, sceneFactory, controller) {
	
		this.scrollMagicScene = new ScrollMagic.Scene({
			triggerElement: this.domElem,
			duration: this.sceneDuration,
			offset: this.sceneOffset,
			triggerHook: this.sceneTriggerHook
		})
		.setTween(this.defaultTween())
		.addTo(controller)
		.setClassToggle( this.domElem, 'active');

		scroll.options.scenes.push(this.scrollMagicScene);
	}

	setTextLetters() {
		const letters = this.domElem.querySelectorAll('.text-wrapper .letters');
		if( letters ) {
			letters.forEach((lettContainer)=>{
				spanWrapAllLetters(lettContainer);
			})
			//this.domLetters = spanWrapAllLetters(letters);
		}
	}

	defaultTween() {

		return this.timeline
		
		.fromTo(
			this.domCards, 
			{
				y: `-25%`,
				webkitFilter: 'blur(20px)',
				autoAlpha: 0,
				scale: .25,
			},
			{
				y: `0%`,
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
				scale: 1,
				ease: Power0.easeInOut,
				//ease: Power0.easeOut
				//stagger: .1,
				stagger: {
					// wrap advanced options in an object
					each: 0.08,
					//from: 'center',
					//from: 'end',
					//from: 'edges',
					from: 'start',
					grid: 'auto',
					ease: Power0.easeInOut,
					//repeat: -1 // Repeats immediately, not waiting for the other staggered animations to finish
				},
				duration: 1,
				overwrite: false,
				//immediateRender: false,
				onComplete: ((e)=>{
					//console.log('CARD ANIMATION COMPLETE', e);
				})
			},
			'-=.5'
		)
		.fromTo(
			this.domElem.querySelectorAll('.news-meta'), 
			{
				y: `-10%`,
				autoAlpha: 0,
			},
			{
				y: `0%`,
				autoAlpha: 1,
				ease: Power0.easeInOut,
				stagger: .1,
				overwrite: false,
				//immediateRender: false,
			},
			'-=.5'
		)
		.fromTo(
			this.domElem.querySelector('.custom-call-to-action'), 
			{
				webkitFilter: 'blur(20px)',
				autoAlpha: 0,
				scale: 1.2,
			},
			{
				webkitFilter: 'blur(0px)',
				autoAlpha: 1,
				scale: 1,
				overwrite: false,
				//immediateRender: false,
				ease: Power0.easeInOut
				//ease: Power0.easeOut
			},
			'-=.5'
		)
		
	}

}
